export enum FrequencyCodes {
  Weekdays = "WD",
  Daily = "D",
  Weekly = "W",
  Monthly = "M",
}
